import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Layout from './components/Layout';
import Planejador from './pages/Planejador';
import Criador from './pages/Criador';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/planejador" replace />} />
            <Route path="planejador" element={<Planejador />} />
            <Route path="criador" element={<Criador />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
